import { reactive } from "vue";
import router from "@/routes";
import service from "@/utils/service";

const newService = new service();

export const store = reactive({
  error: null,
  errorSms: null,
  token: null,
  acenteNo:null,

  captcha: {
    touched: false,
    code: null,
    imageSrc: null,
    input: null,
    error: null,
  },

  sigortali: {
    kimlikNo: null,
    dogumTarihi: null,
    cepNo: null,
    smsDogrulamaKodu: null,
    ePosta: null,
    gizlilikSozlesmeOnay: false,
    elektronikIletiOnay: false,
  },

  isCheckUserPermission: false,
  firstElektronikIletiOnay: true,
  isInsertCampaignPermission: false,
  loading: false,

  formSubmitted: false,
  formSmsSubmitted: false,
  formRedirect: false,

  legalNoticePopupName: null,
  targetPopupName: null,
  setLegalNoticePopupName(name, target = null) {
    this.legalNoticePopupName = name;
    this.targetPopupName = target;
  },
  validationErrorElektronikIletiSozlesmesi() {
    if (this.firstElektronikIletiOnay) {
      return null;
    }
    if (this.sigortali.elektronikIletiOnay) {
      return null;
    }
    return "Sana özel online fiyat çalışması yapabilmemiz için onayına ihtiyacımız var.";
  },
  async getCaptcha() {
    await newService.GetCaptcha({
      onSuccess: (response) => {
        store.captcha.code = response?.code;
        store.captcha.imageSrc = response?.imageSrc;
      },
    });
  },
  async InsertUserCampaignPermission() {
    store.firstElektronikIletiOnay = false;
    if (store.sigortali.elektronikIletiOnay) {
      let response = await newService.InsertUserCampaignPermission({
        Tckn: store.sigortali.kimlikNo,
      });
      if (response.data.Data.Result == "Success") {
        store.isInsertCampaignPermission = true;
        store.legalNoticePopupName = null;
        this.formSubmit();
      }
    }
  },
  async formSubmit() {
    await newService.InsertUpdateLead({
      sigortali: store.sigortali,
      onSuccess: () => {
        store.captcha.input = "";
        store.captcha.touched = false;
        this.goToSms();
      },
      onError: (response) => {
        store.captcha.input = "";
        store.captcha.touched = false;
        store.error = response;
      },
      onCompleted: () => {
        this.getCaptcha();
        this.loading = false;
      },
      acenteNo :store.acenteNo
    });
  },
  goToSms() {
    window.dataLayer.push({
      event: "gaEvent",
      page_path: "/bilgiler",
      event_category: "Kotasyon SMS Submission",
      event_action: "Dijital Saglik Sigortasi",
      event_label: "SMS",
    });

    router.push({
      name: "Sms",
    });
  }
});
